export default "__VITE_PUBLIC_ASSET__55c3bc04__"